import { GrowthBook } from '@growthbook/growthbook-react';

export const growthbook = new GrowthBook({
  apiHost: import.meta.env.VITE_GROWTHBOOK_API_HOST,
  clientKey: import.meta.env.VITE_GROWTHBOOK_CLIENT_KEY ?? 'fakekey',
  enableDevMode: import.meta.env.MODE !== 'production',
  disableCache: import.meta.env.MODE !== 'production',
});
export const LEI_FELCA = 'astro-lei-felca';
